import React from "react";
import '../css/home.css'

const Footer = () => {
    return (
        <div className="footer">
            <div className="footer-heading">
                <h1>BetterWellness</h1>
            </div>

            <div className="footer-content">
                <h3>About us</h3>
                
                    
            </div>
                 <h3>Contact us</h3>
                <h3>Follow Us</h3>
                
        </div>
    )
}

export default Footer;